// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3l2ch","container":"styles_container__19L_P","title":"styles_title__1Y0HB","wrapper":"styles_wrapper__3whQI","answer":"styles_answer__1qEln"};